/**
 * Centralised event configuration.
 *
 * Modifica qui data, orario, luogo e programma dell'evento.
 * Le sezioni Hero / Evento / Programma / Email leggono automaticamente da qui.
 */
export const EVENT_CONFIG = {
    EVENT_NAME: "Presentazione ufficiale SafetyDesk81",
    EVENT_MONTH: "Ottobre 2026",
    EVENT_DATE: "2026-10-01",
    EVENT_DAY_LABEL: "Giovedì 1 ottobre 2026",
    EVENT_APERITIVO_TIME: "18:00",
    EVENT_PRESENTATION_TIME: "19:00",
    EVENT_DINNER_TIME: "20:00",
    EVENT_LOCATION: "Centro Sicurezza Consulenze",
    EVENT_ADDRESS: "Via Bolzano 14/16, Montepulciano (SI)",
    EVENT_PRICE: "",
    EVENT_IS_FREE: false,
    EVENT_LIMITED_SEATS: true,
    EVENT_MAX_ATTENDEES: "",
    EVENT_REGISTRATION_DEADLINE: "",
    EVENT_CONTACT_EMAIL: "info@centrosicurezzaconsulenze.net",
    EVENT_WHATSAPP: "",
    EVENT_STATUS: "registration_open",
};

export function eventDateLine() {
    return EVENT_CONFIG.EVENT_DAY_LABEL;
}
export function eventFullLine() {
    return `${EVENT_CONFIG.EVENT_DAY_LABEL} • ${EVENT_CONFIG.EVENT_ADDRESS}`;
}
export function eventShortLine() {
    return EVENT_CONFIG.EVENT_DAY_LABEL;
}
